import { render, staticRenderFns } from "./ForWho.vue?vue&type=template&id=6fddefe7&scoped=true"
import script from "./ForWho.vue?vue&type=script&lang=js"
export * from "./ForWho.vue?vue&type=script&lang=js"
import style0 from "./ForWho.vue?vue&type=style&index=0&id=6fddefe7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fddefe7",
  null
  
)

export default component.exports